import { useNavigate } from 'react-router-dom';
import { CardList } from '~/pages/MyPage';
import { FullScreenLoading } from '~/components/common';
import { NoMyPageItemMessage } from '~/components/common/NoItemMessage';
import {
  useCharacterLikeMutation,
  useGetMyFavoriteListQuery,
} from '~/features/user';
import { useCreateChatRoom } from '~/hooks';
import { PAGE_ROUTE } from '~/constants';
import Card from '../Card/Card';

export default function LikedCharacter() {
  const navigate = useNavigate();
  const { data } = useGetMyFavoriteListQuery();
  const { mutate: handleCharacterLike } = useCharacterLikeMutation();

  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();

  const handleClickLiked = (id: string) => {
    handleCharacterLike({
      character_id: id,
      operation: 'unlike',
    });
  };

  if (data.length === 0) {
    return (
      <NoMyPageItemMessage
        message={'No favorite yet'}
        buttonTitle={'Go to home'}
        onButtonClick={() => {
          navigate(PAGE_ROUTE.MAIN);
        }}
      />
    );
  }

  return (
    <>
      {isCreateRoomPending && <FullScreenLoading />}
      <CardList>
        {data.map((character) => {
          const { character_id, character_name, character_image, type } =
            character;
          return (
            <Card
              key={character_id}
              id={character_id}
              name={character_name}
              image={character_image}
              type='Liked'
              onClick={() =>
                handleCreateRoomClick({
                  id: character_id,
                  type,
                  image: character_image,
                })
              }
              onIconClick={handleClickLiked}
            />
          );
        })}
      </CardList>
    </>
  );
}
